// extracted by mini-css-extract-plugin
module.exports = {"faqQuestion":"FAQs_faqQuestion__U1_WW","icon":"FAQs_icon__IuOV0","faqAnswer":"FAQs_faqAnswer__3m7TU","faqAnswerActive":"FAQs_faqAnswerActive__oO7ve"};